import { defineStore } from 'pinia'
import { dailyStorage, sharedKeyPersist } from './persistence'

export const useUpsellStore = defineStore('upsell', {
	state: () => ({
		upsellRoutes: [],
		purchasedUpsells: {},
	}),

	getters: {
		getNextUpsellRouteName: (state) => (currentRouteName) => {
			if (state.upsellRoutes.length === 0) {
				return 'update-profile'
			}

			const currentRouteIndex = state.upsellRoutes.indexOf(currentRouteName)

			if (currentRouteIndex === -1) {
				return state.upsellRoutes[0]
			} else if (currentRouteIndex < state.upsellRoutes.length - 1) {
				return state.upsellRoutes[currentRouteIndex + 1]
			}

			return 'update-profile'
		},
	},

	actions: {
		setUpsellRoutes(order) {
			this.upsellRoutes = order
		},

		setPurchasedUpsell(purchasedUpsell) {
			this.purchasedUpsells[purchasedUpsell] = true
		},
	},

	persist: sharedKeyPersist('onedaystorage', 'upsell', dailyStorage),
})
